export default __webpack_public_path__ + "static/media/icon_clock_black.41a0875c.svg";